import * as actions from './actions';
import fieldset from './fieldset/reducer';
import {applyReducers} from '../../../../../helpers';

export default (previousState = {
  currentTab: 'general',
}, action) => {

  const state = applyReducers({ fieldset }, previousState, action);

  switch (action.type) {
    case actions.INIT:
      return {
        ...state,
        projectId: action.projectId,
      };
    case actions.SET_TAB:
      return {
        ...state,
        currentTab: action.value,
      };
    case actions.SAVE.END:
      return {
        ...state,
        origProject: action.origProject,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/general/reducer.js